import { cloneDeep } from "lodash";
import { connect } from "react-redux";
import { Form } from "formik";
import React, { Component } from "react";

import Button from "../../UI/Button";
import CardPrimary from "../../UI/Card/CardPrimary";
import { CustomForm } from "../../../component-library/CustomForm";
import FormikInput from "../../UI/FormikInput";
import FormikInputFormat from "../../UI/formikMobileInput";
import { IN_PROGRESS_STEP } from "../A5Screening";
import { updateA5Details } from "../../../redux/actions/a5Screening";

import {
  A5_START_INITIAL_VALUES,
  A5_START_SCHEMA,
  A5_START_VALIDATION_SCHEMA,
} from "./a5StartSchema";

class A5Start extends Component {
  submitHandler = async (formData, actions) => {
    try {
      actions.setSubmitting(false);
      formData["id"] = this.props.screeningId;
      const data = { ...formData };

      this.props.updateA5Details(data, { dob: formData["dob"] });
      this.props.nextStepHandler(IN_PROGRESS_STEP);
    } catch (e) {
      console.log(e);
    }
  };

  renderForm = (formikProps) => {
    return (
      <Form>
        <div className="mx-auto px-0">
          <div className="container">
            <div className="mx-auto px-0">
              <div className="container">
                <div className="row">
                  {A5_START_SCHEMA.map((field) => {
                    if (field.name === "dob") {
                      return (
                        <div className="col-12 col-lg-6" key={field.name}>
                          <FormikInputFormat
                            errors={formikProps.errors}
                            formEl={field}
                            onChange={async (val) => {
                              await formikProps.setFieldValue("dob", val.value);
                              formikProps.setFieldTouched("dob");
                            }}
                            touched={formikProps.touched}
                            value={formikProps && formikProps.values.dob}
                          />
                        </div>
                      );
                    } else {
                      return (
                        <div className="col-12 col-lg-6" key={field.name}>
                          <FormikInput
                            errors={formikProps.errors}
                            formEl={field}
                            touched={formikProps.touched}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-lg-end tw:justify-center">
          <Button className="Btn Btn--pri mt-4" type="submit">
            Begin Screening Now
          </Button>
        </div>
      </Form>
    );
  };

  render() {
    const initialValues = this.props.a5Details
      ? transformDetailsToInitialValues(this.props.a5Details)
      : cloneDeep(A5_START_INITIAL_VALUES);

    return (
      <div>
        <h1>Hello!</h1>
        <CardPrimary className="mx-auto" style={{ marginTop: 0 }}>
          <CustomForm
            initialValues={initialValues}
            onSubmit={this.submitHandler}
            render={this.renderForm}
            validationSchema={A5_START_VALIDATION_SCHEMA}
          />
        </CardPrimary>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    a5Details: state.a5Screening.a5Details,
  };
};

export default connect(mapStateToProps, {
  updateA5Details,
})(A5Start);

export const transformDetailsToInitialValues = (details) => {
  return {
    current_house: details.current_house ? details.current_house : "",
    dob: details.dob ? details.dob : "",
    ethnicity: details.ethnicity ? details.ethnicity : "",
    first_name: details.first_name ? details.first_name : "",
    gender: details.gender ? details.gender : "",
    hours_work_per_week: details.hours_work_per_week ? details.hours_work_per_week : "",
    last_name: details.last_name ? details.last_name : "",
    marital_status: details.marital_status ? details.marital_status : "",
    middle_name: details.middle_name ? details.middle_name : "",
    persons_living: details.persons_living ? details.persons_living : "",
  };
};
